import request from "@utils/request";

/*
 * 咖啡订单信息入库
 * */
export function coffeeOrderConfirm(data) {
    return request.post("/coffeeConfirm", data);
}

/*PR
 * 支付
 * */
export function payCoffeeOrder(uni, paytype, from) {
    return request.post("/coffeeOrderPay", { uni, paytype, from });
}

/*
 * 获取咖啡订单列表
   type 1=待付款 2=已完成 3=全部订单
   page 1
   limit 20
 * */
export function getCoffeeOrderList(data) {
    return request.get("/order/coffeelist", data);
}

/*
 * 
 获取订单信息:累计、待付款、已完成
 * */
export function getCoffeeOrderData() {
    return request.get("/order/coffeeData");
}
